"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SamplingPoint {
    constructor(obj) {
        this.collecting_at = obj.collecting_at || '';
        this.geodata = obj.geodata || '';
        this.sample_code = obj.sample_code || '';
        this.sample_id = obj.sample_id || -1;
        this.field_name = obj.field_name || '';
    }
}
exports.default = SamplingPoint;
